import {
  TextBase,
  TextLargeParagraph,
  TextLargeParagraphTitle,
  TooltipBubble,
} from '@carboncopyco/ui';
import classNames from 'classnames';
import type { SpeakerViewItem } from './SpeakerViewScreen';

interface NotesScreenProps {
  items: SpeakerViewItem[];
  activeItemIndex: number;
}
export const NotesScreen = ({ items, activeItemIndex }: NotesScreenProps) => {
  const activeItem = items[activeItemIndex];
  const { presentationName } = activeItem;
  return (
    <div className="w-full bg-inherit rounded-md mt-px flex flex-col px-6 max-h-[360px] gap-5 py-5">
      <div className="select-none max-w-100">
        <TooltipBubble
          placement="top"
          title={presentationName}
        >
          <TextLargeParagraphTitle
            label={`Meeting notes ${presentationName}`}
            ellipsis
          />
        </TooltipBubble>
      </div>
      <>
        {items.map((item, index) => {
          const itemNotes = item.notes;
          const isActive = index === activeItemIndex;
          return itemNotes ? (
            <div
              className={classNames(
                'w-full flex-col scrollbar scrollbar-thumb-gray-900 scrollbar-track-gray-100',
                isActive ? 'flex' : 'hidden'
              )}
            >
              <div
                style={{
                  wordWrap: 'break-word',
                }}
                className="h-ds-220 overflow-y-auto overflow-x-hidden select-auto no-drag [&::-webkit-scrollbar]:w-[7px] [&::-webkit-scrollbar]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded  [&::-webkit-scrollbar-thumb]:bg-ds-natural-500"
              >
                <TextLargeParagraph
                  label={itemNotes
                    .split('\n')
                    .map((str: string, index) => (
                      <p key={`${str}${index}`}>
                        {str === '' ? '\u00A0' : str}
                      </p>
                    ))}
                  color="text-ds-accent3-100"
                  tagName="span"
                />
              </div>
            </div>
          ) : (
            <div
              className={classNames(
                'w-full flex h-40 justify-center items-center justify-items-center',
                isActive ? 'flex' : 'hidden'
              )}
            >
              <TextBase
                label="This demo has no notes yet."
                color="text-ds-accent3-100"
              />
            </div>
          );
        })}
      </>
    </div>
  );
};
